import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import './productList.scss';
import { error } from '../../common/helpers/toastify';
import { _Api } from '../api/_call';
import NoOrdersYet from '../../common/module/NoOrdersYet/NoOrdersYet';
import { useSelector } from 'react-redux';
import Loading from '../../common/module/Loading/Loading';
import { useTranslation } from 'react-i18next';
import MixMatchFilter from '../../Custom/MixAndMatch/MixMatchFilter';


const MixMatchProductList = (props) => {
  const { setShowseqs,
    filter,
    setproduct_id,
    showpage,
    Engraving,
    setprice,
    order_edit,
    editproduct,
    customcart,
    scrvicelist,
    scrviceremark,
    skip,
    setSkip,
    remark,
    showseqs,
    order_type,
    order_id,
    productFirst = false,
  } = props
  const { t } = useTranslation()
  const { state } = useLocation()
  const navigate = useNavigate()
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const customer = useSelector((state) => state.app.customer)
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const [Salefilter, setSalefilter] = useState('top_sale')
  const [productlist, setProductlist] = useState()
  const [Loadingstatus, setLoadingstatus] = useState(false);
  const [shoremorelodar, setShowmorelodar] = useState(false)
  const [Totalproduct, setTotalproduct] = useState(0);
  const [mmFilters, setMmFilters] = useState(null);
  const mmFiltersRef = useRef(null);
  const [itemOptions, setItemOptions] = useState([]);
  const defaultLastItemAppliedRef = useRef(false);
  const itemType = filter?.Optiondetails ? 'catalog' : 'inventory';

  const handleFilterChange = (next) => {
    mmFiltersRef.current = next;
    setSkip(0);
    setMmFilters(next);
  };

  const handleItemPick = (row) => {
    if (!row?._id) return;
    setproduct_id?.('');
    setSkip?.(0);
    navigate('.', {
      replace: true,
      state: {
        ...state,
        items: { id: row._id, name: row.name },
        product_id: '',
        itemchanges: undefined,
        mixMatchFlow:
          state?.mixMatchFlow ??
          (!state?.daimond_id ? 'product_first' : undefined),
      },
    });
  };

  const getproducts = async () => {
    if (shoremorelodar) {
      setShowmorelodar(true)
    } else {
      setLoadingstatus(true);
    }
    try {
      const activeFilters = mmFiltersRef.current || mmFilters;
      const postdata = {
        item: state ? state?.items?.id : '',
        type: itemType,
        limit: 40,
        sale: Salefilter,
        customer_id: customer?.id,
        skip: skip,
        style: activeFilters?.style || [],
        shape: activeFilters?.shape || [],
        metal: activeFilters?.metal || [],
        price: activeFilters?.price || null,
      }
      let res = await _Api(
        postdata,
        `api/v1/POS/customOrder/mixAndMatch/getProductListByItem`,
      )
      if (res.code === 200) {
        if (skip === 0) {
          setProductlist(res?.data)
        } else {
          let finaldata = [...productlist]
          let data = finaldata.concat(res?.data)
          setProductlist(data)
        }
        setLoadingstatus(false);
        setTotalproduct(res?.total)
        setShowmorelodar(false)
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  const wishlistset = async (sku, product_id, wishliststatus, i,Item) => {
    if (!customer?.id) {
      error(t('Customer is Requried!!'))
      return
    }
    try {
      const postdata = {
        customer_id: customer?.id,
        isWishlist: wishliststatus === 0 ? 0 : wishliststatus,
        SKU: sku,
        type: filter?.Optiondetails ? 'catalog' : 'inventory',
        product_id: product_id,
        item_id:Item
      }
      let res = await _Api(postdata, `api/v1/POS/wishlist/updateWishlist`)
      if (res.code === 200) {
        let arry = [...productlist]
        arry[i] = {
          ...arry[i],
          'isWishlist': res?.data?.isWishlist,
        }
        setProductlist(arry)
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await _Api(
          { type: 'mixAndMatch' },
          `api/v1/POS/home/itemList`,
        );
        if (cancelled) return;
        if (res.code === 200 && Array.isArray(res?.data)) {
          setItemOptions(res.data);
        } else {
          setItemOptions([]);
        }
      } catch (err) {
        console.log(err, 'err');
        if (!cancelled) setItemOptions([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);
  useEffect(() => {
    if (!productFirst || showseqs !== 0) return;
    if (!itemOptions.length) {
      defaultLastItemAppliedRef.current = false;
      return;
    }
    if (state?.items?.id) return;
    if (defaultLastItemAppliedRef.current) return;
    const last = itemOptions[itemOptions.length - 1];
    if (!last?._id) return;
    defaultLastItemAppliedRef.current = true;
    setproduct_id?.('');
    setSkip?.(0);
    navigate('.', {
      replace: true,
      state: {
        ...state,
        items: { id: last._id, name: last.name },
        product_id: '',
        itemchanges: undefined,
        mixMatchFlow:
          state?.mixMatchFlow ??
          (!state?.daimond_id ? 'product_first' : undefined),
      },
    });
  }, [
    productFirst,
    showseqs,
    itemOptions,
    navigate,
    setSkip,
    setproduct_id,
  ]);
  useEffect(() => {
    if (filter?.Optiondetails !== null) {
      getproducts()
    }
    // eslint-disable-next-line 
  }, [filter?.Optiondetails, customer?.id, showseqs === 0, mmFilters, Salefilter, state?.items?.id])
  return (
    <>
      {
        Loadingstatus ? <Loading /> : ''
      }
      {filter?.Optiondetails !== null ? (
        <MixMatchFilter
          itemId={state?.items?.id}
          itemName={state?.items?.name}
          type={itemType}
          onChange={handleFilterChange}
          itemOptions={itemOptions}
          onItemChange={handleItemPick}
        />
      ) : null}
      <div className="product-filter-bar">
        <div className="product-filter-bar-left common-select">
          <label className="product-filter-bar-left-label">
            {state ? state?.items?.name : ''}
          </label>
          <div className="dropdown">
            <button
              className="btn btn-secondary dropdown-toggle"
              type="button"
              id="graph"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                className=""
                src={base_assets + 'images/pos/icons/graph-icon.png'}
                alt=""
              />
            </button>
            <ul className="dropdown-menu" aria-labelledby="graph">
              <li className="dropdown-item">
                <img
                  className=""
                  onClick={() => setSalefilter('top_sale')}
                  src={base_assets + 'images/pos/icons/top-sale.png'}
                  alt=""
                />{' '}
                Top sales
              </li>
              <li className="dropdown-item">
                <img
                  className=""
                  onClick={() => setSalefilter('lowest_sale')}
                  src={base_assets + 'images/pos/icons/up-sale.png'}
                  alt=""
                />{' '}
                lowest sales
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="products-list">
        <div className="products-list-row">
          {
            productlist?.length ? (
              productlist?.map((result, hkey) => {
                return (
                  <div className="products-list-row-single" key={result?.id}>
                    <Link
                      to="/app/pos/custom/mixdiamondsetting"
                      state={{
                        product_id: result?.product_id,
                        filter: filter,
                        daimond_id: state?.daimond_id,
                        items: state?.items,
                        showpage: showpage,
                        Engraving: Engraving,
                        editproduct: editproduct,
                        customcart: customcart,
                        scrvicelist: scrvicelist,
                        scrviceremark: scrviceremark,
                        remark: remark
                      }}
                      className="link-style"
                    >
                      <div className="products-list-row-single-img">
                        <img
                          className="products-cat-row-single-img"
                          src={result?.main_image ? result?.main_image : ''}
                          alt=""
                        />
                      </div>
                      <div className="products-list-row-single-ct pb-0">
                        <div className='products-list-row-single-ct-name-wrap'>
                          <h2 className="products-list-row-single-ct-name mb-0">
                            {result?.name}
                          </h2>
                          <span className='products-list-row-single-ct-name d-block fw-semibold h-auto spinnercolor'>{result?.SKU}</span>
                        </div>
                      </div>
                    </Link>
                    <div
                      onClick={() => result?.isWishlist ?
                        (parmissiondatashow?.WishList?.Delete && wishlistset(result?.SKU, result?.product_id, result?.isWishlist, hkey,result?.Item)) :
                        (parmissiondatashow?.WishList?.Add && wishlistset(result?.SKU, result?.product_id, result?.isWishlist, hkey,result?.Item))}
                    >
                      <i
                        className={
                          result?.isWishlist === 1
                            ? 'fa fa-heart wishlist-icon'
                            : 'fa fa-heart-o wishlist-icon'
                        }
                      ></i>
                    </div>
                    <div className="products-list-row-single-ct pt-0">
                      <div className="products-list-row-single-ct-bottom">
                        <p className="products-list-row-single-ct-bottom-price">
                          {result?.price ? result?.price : ''}
                        </p>
                        {state?.daimond_id ?
                          order_edit ?
                            (
                              <Link
                                to="/app/pos/custom/mixdiamondsetting"
                                className="products-list-row-single-ct-bottom-add"
                                state={{
                                  product_id: result?.product_id,
                                  filter: filter,
                                  daimond_id: state?.daimond_id,
                                  items: state?.items,
                                  showpage: showpage,
                                  Engraving: Engraving,
                                  editproduct: editproduct,
                                  customcart: customcart,
                                  scrvicelist: scrvicelist ? scrvicelist : [],
                                  scrviceremark: scrviceremark,
                                  remark: remark,
                                  order_edit: order_edit,
                                  order_id: order_id,
                                  order_type: order_type,

                                }}
                              >
                                <img
                                  src={base_assets + 'images/pos/icons/add-pro.png'}
                                  alt=""
                                />

                              </Link>
                            ) :
                            filter?.Optiondetails ?
                              (
                                <Link
                                  to="/app/pos/custom/mixdiamondsetting"
                                  state={{
                                    product_id: result?.product_id,
                                    filter: filter,
                                    daimond_id: state?.daimond_id,
                                    items: state?.items,
                                    showpage: showpage,
                                    Engraving: Engraving,
                                    editproduct: editproduct,
                                    customcart: customcart,
                                    scrvicelist: scrvicelist ? scrvicelist : [],
                                    scrviceremark: scrviceremark,
                                    remark: remark

                                  }}
                                  className="products-list-row-single-ct-bottom-add"
                                >

                                  <img
                                    src={base_assets + 'images/pos/icons/add-pro.png'}
                                    alt=""
                                  />
                                </Link>
                              ) :
                              (
                                <button
                                  className="products-list-row-single-ct-bottom-add"
                                  onClick={() => {
                                    setShowseqs(showpage ? 2 : 1)
                                    setproduct_id(result?.id)
                                    setprice(result?.price)
                                  }}
                                >
                                  <img
                                    src={base_assets + 'images/pos/icons/add-pro.png'}
                                    alt=""
                                  />

                                </button>
                              ) : (
                            <Link
                              to="/app/pos/custom/mixAndMatch"
                              state={{
                                daimond_id: '',
                                items: state?.items,
                                product_id: result?.id,
                                bychangeorder: true,
                                mixMatchFlow: state?.mixMatchFlow,
                              }}
                              className="products-list-row-single-ct-bottom-add"
                            >

                              <img
                                src={base_assets + 'images/pos/icons/add-pro.png'}
                                alt=""
                              />
                            </Link>
                          )}
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (
              <NoOrdersYet />
            )
          }
        </div>
      </div>
      {shoremorelodar ?
        <div className="border-bottom-0 d-block main-green-text mx-auto my-4 spinner-border flex-shrink-0" role="status"></div> : ""}
      {productlist?.length !== 0 && productlist?.length !== Totalproduct ?
        <div className="show-more show-more-fixed">
          <span className='show-more-displaying'>{t("Displaying")} {productlist?.length ? productlist?.length : 0} {t("of")} {Totalproduct} {t("items")}</span>
          <button className={shoremorelodar ? "btn show-more-btn disabled" : "btn show-more-btn"} onClick={() => { setSkip(skip + 10); setShowmorelodar(true); setShowmorelodar(true) }}>
            Show more <img src={base_assets + "images/icons/add-icon.png"} alt="" /></button></div>
        : ""}
    </>
  )
}

export default MixMatchProductList;
